import { inject, injectable } from "inversify";
import { ICPLMeetingsClient, MeetingFiltersModel, MeetingModel } from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface IMeetingsService {
  getMeeting(meetingID: number): Promise<MeetingModel>;
  getMeetings(meetingFiltersModel: MeetingFiltersModel): Promise<MeetingModel[]>;
  createMeeting(newMeetingStatusTypeModel: MeetingModel): Promise<number>;
  updateMeeting(meetingStatusTypeModel: MeetingModel): Promise<void>;
  deleteMeeting(meetingID: number): Promise<void>;
}

@injectable()
export class MeetingsService implements IMeetingsService {
  @inject(SERVICE_TYPES.CPLMeetingsClient) cplMeetingsClient!: ICPLMeetingsClient;

  async getMeetings(meetingFiltersModel: MeetingFiltersModel): Promise<MeetingModel[]> {
    return this.cplMeetingsClient.getMeetings(meetingFiltersModel);
  }

  async getMeeting(meetingID: number): Promise<MeetingModel> {
    return this.cplMeetingsClient.getMeeting(meetingID);
  }

  async createMeeting(newMeetingModel: MeetingModel): Promise<number> {
    return this.cplMeetingsClient.createMeeting(newMeetingModel);
  }

  async updateMeeting(meetingModel: MeetingModel): Promise<void> {
    return this.cplMeetingsClient.updateMeeting(meetingModel);
  }

  async deleteMeeting(meetingID: number): Promise<void> {
    return this.cplMeetingsClient.deleteMeeting(meetingID);
  }
}
